exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".instruction-text[data-v-c912bcd8]{background:#f8f9fa;border:1px solid #dee2e6;border-radius:8px;padding:15px;margin-bottom:20px}.instruction-text__content[data-v-c912bcd8]{display:flex;align-items:flex-start;gap:12px}.instruction-text__icon[data-v-c912bcd8]{flex-shrink:0;margin-top:2px}.instruction-text__text[data-v-c912bcd8]{flex:1;font-size:14px;line-height:1.5;color:#495057}.instruction-text__text strong[data-v-c912bcd8]{color:#212529;font-weight:600}", ""]);

// exports
